import {
  fsXXS,
  fwBold,
} from '@aboutyou/legacy-shared/src/ui/constants/typography'
import { exists } from '@aboutyou/legacy-shared/src/utils/exists'
import { RecoSectionContent } from '@aboutyou/legacy-tracking-sdk'
import { useTranslation } from 'helpers/hooks/useTranslation'
import { RecoSliderSectionTrackingContextProvider } from 'helpers/tracking/SectionTrackingContext'
import React, { FC, useState } from 'react'
import { useService } from 'services/utils/context'
import ProductTileConnected from 'sharedComponents/ProductTileConnected/ProductTileConnected'
import { usePremiumPageStore } from 'store/context'
import styled, { css } from 'styled-components'
import { complementaryColor, primaryColor } from 'uiComponents/constants/colors'
import HorizontalSlider from 'uiComponents/molecules/Slider/HorizontalSlider'
import PremiumLandingSection from './PremiumLandingSection'
import { SectionHeaderPadded } from './PremiumSectionHeaders'

const FilterList = styled.ul`
  display: flex;
  list-style: none;
  margin-bottom: 23px;
  margin-left: 60px;
`

const BrandItem = styled.li<{ selected: boolean }>`
  font-size: ${fsXXS}px;
  margin-right: 20px;
  border-bottom: 2px solid ${complementaryColor};
  text-transform: uppercase;

  :hover {
    cursor: pointer;
    border-bottom: 2px solid ${primaryColor};
  }
  ${props =>
    props.selected &&
    css`
      ${fwBold};
      border-bottom: 2px solid ${primaryColor};
    `};
`

const PremiumProducts: FC = () => {
  const { t } = useTranslation()
  const [selectedBrand, setSelectedBrand] = useState<string>('all')
  const service = useService()
  const { fetchProductsByBrand } = usePremiumPageStore()
  const brandIds = usePremiumPageStore(store => store.brandIdsForProductSlider)
  const productIds = usePremiumPageStore(store => store.productIds)

  const brands = brandIds
    .map(id => service.brands.getByBrandId(id))
    .filter(exists)

  const handleBrandSelect = async (id: string) => {
    fetchProductsByBrand(id)
    setSelectedBrand(id)
  }

  if (brands.length === 0 || productIds.length === 0) {
    return null
  }

  const sectionTitle = t('Premium Neuheiten')

  return (
    <PremiumLandingSection
      sectionTitle={<SectionHeaderPadded title={sectionTitle} />}
    >
      <FilterList>
        <BrandItem
          key={'all'}
          onClick={() => handleBrandSelect('all')}
          selected={selectedBrand === 'all'}
        >
          {t('Alle Marken')}
        </BrandItem>
        {brands.map(brand => {
          return (
            <BrandItem
              key={brand.id}
              onClick={() => handleBrandSelect(brand.id)}
              selected={selectedBrand === brand.id}
            >
              {brand.name}
            </BrandItem>
          )
        })}
      </FilterList>
      <RecoSliderSectionTrackingContextProvider
        headline={sectionTitle}
        recoType={RecoSectionContent.newPremiumProducts}
      >
        <HorizontalSlider
          showsProductTiles
          slideCount={3}
          slideCountMedium={4}
          slideCountLarge={5}
          disableHeaderControl
          resetScrolling
        >
          {productIds.map(id => (
            <ProductTileConnected key={id} productId={id} />
          ))}
        </HorizontalSlider>
      </RecoSliderSectionTrackingContextProvider>
    </PremiumLandingSection>
  )
}

export default PremiumProducts
